import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import type { ActionButtonsConfig } from "./ActionButtons.d";

const { Stack, Button } = Chakra;

const ActionButtons = ({ buttons }: { buttons: Array<ActionButtonsConfig> }) => {
  const translations = useTranslations();
  return (
    <Stack spacing={{ base: 4, lg: 3 }} direction={{ base: "column", lg: "row" }} w={{ base: "full", lg: "auto" }}>
      {buttons.map(({ href, variant, translationKey, dataTestId, color }) => (
        <Button
          key={translationKey}
          variant={variant}
          href={href}
          color={color}
          title={translations(translationKey)}
          as="a"
          _visited={{}}
          data-testid={dataTestId}
        >
          {translations(translationKey)}
        </Button>
      ))}
    </Stack>
  );
};

export default ActionButtons;
